import React from 'react';

const MeshBackgroundCenterOverlay = ({ children }: React.PropsWithChildren) => {
    return (
        <div className="mesh-background bg-muted flex min-h-svh flex-col items-center justify-center px-4 py-10 md:px-8 md:py-16">
            <div className="mx-auto flex w-full max-w-md flex-col items-center">{children}</div>
        </div>
    );
};

export default MeshBackgroundCenterOverlay;
